// Area endpoints — list + create only (backend has no GET-by-id).

import { request, type ApiResponse } from "../client";
import type { AreaCreate, AreaOut } from "../types/area";

export const areas = {
  list: (
    accountSlug: string,
    tenantSlug: string,
    siteSlug: string,
    floorSlug: string,
  ): Promise<ApiResponse<AreaOut[]>> =>
    request<AreaOut[]>(
      "GET",
      `/api/v1/accounts/${encodeURIComponent(accountSlug)}/tenants/${encodeURIComponent(tenantSlug)}/sites/${encodeURIComponent(siteSlug)}/floors/${encodeURIComponent(floorSlug)}/areas`,
    ),

  create: (
    accountSlug: string,
    tenantSlug: string,
    siteSlug: string,
    floorSlug: string,
    body: AreaCreate,
  ): Promise<ApiResponse<AreaOut>> =>
    request<AreaOut>(
      "POST",
      `/api/v1/accounts/${encodeURIComponent(accountSlug)}/tenants/${encodeURIComponent(tenantSlug)}/sites/${encodeURIComponent(siteSlug)}/floors/${encodeURIComponent(floorSlug)}/areas`,
      body,
    ),
};
